import { 
  ForgotPasswordRequest, 
  ForgotPasswordResponse, 
  VerifyTokenResponse, 
  ResetPasswordRequest, 
  ResetPasswordResponse 
} from '../types'

/**
 * Request password reset for email
 */
export const requestPasswordReset = async (data: ForgotPasswordRequest): Promise<ForgotPasswordResponse> => {
  try {
    const response = await fetch('/api/forgot-password/request', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    const result = await response.json()

    if (!response.ok) {
      throw new Error(result.message || 'Failed to request password reset')
    }

    return result
  } catch (error: any) {
    throw new Error(error.message || 'Network error occurred')
  }
}

/**
 * Verify if reset token is valid
 */
export const verifyResetToken = async (token: string): Promise<VerifyTokenResponse> => {
  try {
    const response = await fetch(`/api/forgot-password/verify/${token}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    const result = await response.json()

    if (!response.ok) {
      throw new Error(result.message || 'Token verification failed')
    }

    return result
  } catch (error: any) {
    throw new Error(error.message || 'Network error occurred')
  }
}

/**
 * Reset password using token
 */
export const resetPassword = async (data: ResetPasswordRequest): Promise<ResetPasswordResponse> => {
  try {
    const response = await fetch('/api/forgot-password/reset', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    const result = await response.json()

    if (!response.ok) {
      throw new Error(result.message || 'Password reset failed')
    }

    return result
  } catch (error: any) {
    throw new Error(error.message || 'Network error occurred')
  }
}
